import React, { useContext } from 'react';
import CartItem from './CartItem';
import CartMenuItem from './CartMenuItem';
import CartMenuPicker from './CartMenuPicker';
import './Cart.css'; // Assurez-vous de créer ce fichier CSS pour le style
import './CartMenuItem.css'; // Assurez-vous de créer ce fichier CSS pour le style
import { CartContext } from '../context/CartContext';
import { Button, Alert } from '@mui/material'; // Import de l'alerte depuis Material-UI
import { useNavigate } from 'react-router-dom';

const Cart = ({ categories, isOpen, setIsOpen }) => {
  const { cartItems, total, clearCart, menuChoices } = useContext(CartContext);
  const navigate = useNavigate();

  // console.log('Cart Items:', cartItems);
  // console.log('Menu Choices:', menuChoices);

  const handleOrderClick = () => {
    setIsOpen(false); // Ferme le panier avant de naviguer
    navigate('/cart-summary');
  };

  // On associe chaque message à l'uniqueId de l'item
  const validationMessages = cartItems.map(item => {
    const menuChoice = menuChoices[item.uniqueId];

    if (item.options && item.options.all) {
      if (!menuChoice || !menuChoice.selectedItems || menuChoice.selectedItems.length !== item.nb[0]) {
        return { message: `Le menu "${item.nom}" nécessite ${item.nb[0]} items sélectionnés.`, uniqueId: item.uniqueId };
      }
    } else if (item.options) {
      if (!menuChoice || !menuChoice.isValid) {
        return { message: `Le menu "${item.nom}" n'est pas encore validé.`, uniqueId: item.uniqueId };
      }
    }

    return null;
  }).filter(obj => obj !== null);

  const isOrderComplete = validationMessages.length === 0;

  // Fonction pour scroller jusqu'à l'élément du menu à valider
  const scrollToMenu = (uniqueId) => {
    const el = document.getElementById(`menu-item-${uniqueId}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('highlight-menu');
      setTimeout(() => el.classList.remove('highlight-menu'), 1500);
    }
  };

  return (
    <div className={`cart ${isOpen ? 'open' : ''}`}>
      {isOpen && (
        <div className="cart-content">
          <h1>Commande</h1>
          <h2>Total: {total.toFixed(2)} €</h2>
          <Button
            variant="contained"
            className="secondaryBg"
            fullWidth
            onClick={handleOrderClick}
            disabled={!isOrderComplete}
          >
            Commander
          </Button>
          {/* Affichage des alertes sous le bouton "Commander" */}
          {validationMessages.length > 0 && (
            <div className="validation-alerts">
              {validationMessages.map((obj, index) => (
                <Alert
                  key={index}
                  severity="warning"
                  style={{ marginTop: '10px', cursor: 'pointer' }}
                  onClick={() => scrollToMenu(obj.uniqueId)}
                >
                  {obj.message}
                </Alert>
              ))}
            </div>
          )}
          <Button className="clear-cart-link" onClick={clearCart}>
            Vider le panier
          </Button>
          <ul>
            {cartItems.map((item, index) => (
              item.options && item.options.all ? (
                <li key={item.uniqueId} id={`menu-item-${item.uniqueId}`}>
                  <CartMenuPicker menu={item} categories={categories} />
                </li>
              ) : (
                item.options ? 
                  <li key={item.uniqueId} id={`menu-item-${item.uniqueId}`}>
                    <CartMenuItem menu={item} categories={categories} />
                  </li>
                  :
                  <li key={item.uniqueId}>
                    <CartItem item={item} />
                  </li>
              )
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Cart;
